import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class ToggleButton extends Component {
    static propTypes = {
        open: PropTypes.bool.isRequired,
        show: PropTypes.bool.isRequired,
        toggleRibbonAction: PropTypes.func.isRequired,
    }

    onClickHandler = () => {
        const { open, toggleRibbonAction } = this.props

        toggleRibbonAction(!open)
    }

    render() {
        const { open, show } = this.props
        return <div className={cx('toggle-button', !open && 'hide', !show && 'none')} onClick={this.onClickHandler} />
    }
}
